import * as React from 'react';
import { 
  Box,
  CircularProgress,
  DialogContent,
  IconButton,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Grid
} from '@mui/material';

import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../../components/common/Modal';

import { createUser, updateUser } from '../../slices/user';

export default function UserModal(props) {
  const {open, mode, data, handleClose} = props;

  const [loading, setLoading] = React.useState(false);
  const [role, setRole] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [firstname, setFirstname] = React.useState("");
  const [lastname, setLastname] = React.useState("");
  const [id, setId] = React.useState('');

  const dispatch = useDispatch();

  const roleMap = {
    'SUPER_ADMIN': 1,
    'ADMIN': 2,
    'USER': 3
  }

  React.useEffect(() => {
    if(mode === "Create") {
      setRole("");
      setEmail("");
      setFirstname("");
      setLastname("");
    } else {
      const {id: originId, email: originEmail, firstname: originFirstname, lastname: originLastname, role: originRole} = data;
      setId(originId);
      setEmail(originEmail);
      setFirstname(originFirstname);
      setLastname(originLastname);
      setRole(roleMap[originRole]);
    }
  }, [mode, data])

  const handleRole = (e) => {
    setRole(e.target.value)
  }

  const handleEmail = (e) => {
    setEmail(e.target.value)
  }

  const handleFirstname = (e) => {
    setFirstname(e.target.value)
  }
  
  const handleLastName = (e) => {
    setLastname(e.target.value)
  }
  const handleSave = (e) => {
    setLoading(true);
    let formData = new FormData();
    formData.append('email', email);
    formData.append('first_name', firstname);
    formData.append('last_name', lastname);
    formData.append('role', role);
    console.log(formData)
    if(mode === 'Create') {
      dispatch(createUser(formData))
        .then(res => {
          setLoading(false);
          handleClose();
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
        }      
      )
    } else {
      formData.append('id', id);
      dispatch(updateUser(formData))
        .then(res => {
          setLoading(false);
          handleClose();
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
        }      
      )
    }
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth
      >
        <CDialogTitle>New User</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <FormControl sx={{ mt: 1, minWidth: 120 }} size="small" fullWidth>
          <InputLabel id="demo-select-small-label">Role</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={role}
            label="Role"
            onChange={handleRole}
          >
            <MenuItem value={1}>SUPER ADMIN</MenuItem>
            <MenuItem value={2}>ADMIN</MenuItem>
            <MenuItem value={3}>USER</MenuItem>
          </Select>
        </FormControl>

        <CTextField
          id={`email`} 
          label={`Email`}
          size="small"
          variant="outlined"
          value={email}
          onChange={handleEmail}
          sx={{
            marginTop: '1rem'
          }}
          fullWidth
        />
          
        <Grid spacing={2} container>
          <Grid xs={6} item>
            <CTextField
              id={`firstname`} 
              label={`First name`}
              size="small"
              variant="outlined"
              value={firstname}
              onChange={handleFirstname}
              sx={{
                marginTop: '1rem'
              }}
              fullWidth
            />
          </Grid>
          <Grid xs={6} item>
            <CTextField
              id={`lastname`} 
              label={`Last name`}
              size="small"
              variant="outlined"
              value={lastname}
              onChange={handleLastName}
              sx={{
                marginTop: '1rem'
              }}
              fullWidth
            />
          </Grid>
        </Grid>
        {loading && (
            <Box className="absolute w-full h-full" sx={{top: 0, left: 0}}>
              <Box className="relative w-full h-full">
                <Box className="w-full h-full flex justify-center align-center">
                  <CircularProgress sx={{opacity: 0.7}} />
                </Box>
              </Box>
            </Box>)
          }  
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleSave}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}